import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { GetEnumValuesDto, PhonebookTypes } from 'src/app/core/api/models';
import { EnumsService } from 'src/app/core/api/services';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { BaseSelectionList } from '../base/base-selection-list.component';
import { PhonebooksService } from './../../../../core/api/services/phonebooks.service';

@Component({
    selector: 'phonebook-selection-list',
    templateUrl: './phonebook-selection-list.component.html',
    standalone: false
})
export class PhonebookSelectionList
  extends BaseSelectionList
  implements OnInit
{
  @Input('type') input_type:
    | 'phonebooks'
    | 'phonebooksByContactId'
    | 'currentOrganizationPhonebooks'
    | 'phonebooksListForServices'
    | 'phonebooksForDevice' = 'phonebooks';
  @Input() hasCustomClass: boolean = false;

  PhonebookTypesEnumValues: GetEnumValuesDto[] = [];
  PhonebookType: PhonebookTypes;
  get PhonebookTypes() {
    return PhonebookTypes;
  }

  constructor(
    protected currentService: PhonebooksService,
    private enumService: EnumsService,
    private enumToTextConvertorPipe: EnumToTextConvertorPipe
  ) {
    super();
  }

  @Input() showPrivacyDropdown: boolean = true;

  ngOnInit() {
    this.initConfig();
    this.getItems();

    this.getEnumValuesApi('PhonebookTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.PhonebookTypesEnumValues = values));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.hasCustomClass) {
      this.input_searchBoxGridClass =
        'xl:tw-w-1/2 xl:tw-pl-[25px] xl:ltr:tw-pr-[25px]';
    }
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
    this.sortKey = 'id';

    if (!this.input_label) this.input_label = 'common.group';
  }

  onChangeType(event) {
    this.PhonebookType = event.value;
    this.getItems();
  }

  getItems() {
    if (this.loading) return;

    this.loading = true;

    switch (this.input_type) {
      case 'phonebooks':
        this.currentService
          .phonebooksGetPhonebooksListByOrganizationId({
            PhonebookTypes: this.PhonebookType,
          })
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                const translatedPhoneBookType =
                  this.enumToTextConvertorPipe.transform(
                    item.phonebookTypes,
                    this.PhonebookTypesEnumValues
                  );
                return {
                  ...item,
                  // optionTitle: `${item.name} (${item.contactsCount})`
                  optionTitle: ` <span> ${item.name}
                      <b class='tw-px-1'> (${translatedPhoneBookType})</b>
                      </span>`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
      case 'phonebooksByContactId':
        this.currentService
          .phonebooksGetPhonebooksByContactsId({
            body: {
              contactId: this.id.toString(),
            },
          })
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.name}`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
      case 'currentOrganizationPhonebooks':
        this.currentService
          .phonebooksGetCurrentOrganizationPhonebooksList()
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.name}`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
      case 'phonebooksListForServices':
        this.currentService
          .phonebooksGetPhonebooksListForServices()
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                return {
                  ...item,
                  optionTitle: `${item.name}`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });
        break;
      case 'phonebooksForDevice':
        this.currentService
          .phonebooksGetPhonebooksForDevicesByOrganizationId({
            OrganizationId: +this.id,
          })
          .pipe(
            this.baseSelectionSearchPipeOperators,
            map((items) => {
              return items?.data.map((item) => {
                const translatedPhoneBookType =
                  this.enumToTextConvertorPipe.transform(
                    item.phonebookTypes,
                    this.PhonebookTypesEnumValues
                  );
                return {
                  ...item,
                  optionTitle: `${item.name}`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
      default:
        break;
    }
  }

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    if (SavedEnumsService.getEnum(enumName) != null)
      return SavedEnumsService.getEnumAsObservable(enumName);

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: enumName })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((newEnum) => {
        SavedEnumsService.pushEnum({
          enumName: enumName,
          enumValue: newEnum.data,
        });
      });

    // save enum
    return this.enumService.enumsGetEnumValues({ EnumTypeName: enumName }).pipe(
      takeUntil(this.onDestroy$),
      map((res) => res.data)
    );
  }
}
